import React from "react";
import { Heading } from "../../Heading";
import { ImgV2 } from "../../ImgV2";
export const License = ({ description, iconUrl, title, imageAlt }) => (React.createElement("div", { className: 'license-root' },
    React.createElement(ImgV2, { src: iconUrl, alt: imageAlt }),
    React.createElement(Heading, { design: "h3-bold-small" }, title),
    React.createElement("p", { className: "license-root__description" }, description)));
